import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { PAYMENTS_ROOT_URL } from '@/config';
import {
  PRIVATE_NAVIGATION_TAB_ACCOUNT,
  PRIVATE_NAVIGATION_TAB_INVOICES,
  PRIVATE_NAVIGATION_TAB_PRODUCTS,
  PRIVATE_NAVIGATION_TAB_RATE,
} from '@/config/appConstants';
import { getMyRateURL } from '@/utils/helpers';

export type AccountNavigationBarProps = {
  tabSelected?:
    | typeof PRIVATE_NAVIGATION_TAB_PRODUCTS
    | typeof PRIVATE_NAVIGATION_TAB_ACCOUNT
    | typeof PRIVATE_NAVIGATION_TAB_RATE
    | typeof PRIVATE_NAVIGATION_TAB_INVOICES;
  className?: string;
};

const AccountNavigationBarWrap = styled.div`
  .nav {
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-wrap: nowrap;
    list-style: none;
    margin-bottom: 0;
    padding-left: 0;
    padding-top: 0;
  }
  .nav li {
    border-bottom: 2px solid var(--md-lightGray-color);
    box-sizing: content-box;
    flex-grow: 1;
    height: auto;
    text-align: center;
  }
  .nav li:hover {
    border-color: var(--md-blue-color);
  }
  .nav li.active {
    border-color: var(--md-turquoise-color);
  }
  .nav li a {
    background: inherit;
    border-radius: 4px 4px 0 0;
    border: 1px solid transparent;
    box-shadow: none;
    color: var(--md-blue-color);
    display: block;
    font-weight: 600;
    line-height: 1.42857143;
    margin-right: 2px;
    text-transform: uppercase;
  }
`;

export const AccountNavigationBar = ({ tabSelected, className }: AccountNavigationBarProps) => {
  const { t } = useTranslation();
  const getAccountNavigationBarATagStyles = () =>
    'font-secondary font-bold text-md-blue px-0 py-5 lg:p-8 lg:py-5 text-xs lg:text-[15px] hover:no-underline';

  return (
    <section className={className}>
      <AccountNavigationBarWrap>
        <ul className="nav">
          <li
            className={clsx({
              active: tabSelected === PRIVATE_NAVIGATION_TAB_PRODUCTS,
            })}
          >
            <a
              href={`${PAYMENTS_ROOT_URL}account/products`}
              className={getAccountNavigationBarATagStyles()}
            >
              <span className="hidden lg:block">{t('AccountNavigationBar.products')}</span>
              <span className="block lg:hidden">{t('AccountNavigationBar.products_short')}</span>
            </a>
          </li>

          <li
            className={clsx({
              active: tabSelected === PRIVATE_NAVIGATION_TAB_ACCOUNT,
            })}
          >
            <a
              href={`${PAYMENTS_ROOT_URL}account/my-account`}
              className={getAccountNavigationBarATagStyles()}
            >
              <span className="hidden lg:block">{t('AccountNavigationBar.account')}</span>
              <span className="block lg:hidden">{t('AccountNavigationBar.account_short')}</span>
            </a>
          </li>

          <li
            className={clsx({
              active: tabSelected === PRIVATE_NAVIGATION_TAB_RATE,
            })}
          >
            <a href={getMyRateURL()} className={getAccountNavigationBarATagStyles()}>
              {t('AccountNavigationBar.myRate')}
            </a>
          </li>
          <li
            className={clsx({
              active: tabSelected === PRIVATE_NAVIGATION_TAB_INVOICES,
            })}
          >
            <a
              href={`${PAYMENTS_ROOT_URL}account/my-invoices`}
              className={getAccountNavigationBarATagStyles()}
            >
              {t('AccountNavigationBar.myInvoices')}
            </a>
          </li>
        </ul>
      </AccountNavigationBarWrap>
    </section>
  );
};
